import { render } from "./SelectTTPPTdk.vue?vue&type=template&id=076d12d5"
import script from "./SelectTTPPTdk.vue?vue&type=script&lang=js"
export * from "./SelectTTPPTdk.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__